const configuredApiUrl = import.meta.env.VITE_API_BASE_URL?.trim();

export const API_BASE_URL = (
  configuredApiUrl ||
  'https://api.umasaura.com'
).replace(/\/+$/, '');
